import clsx from 'clsx';
import React from 'react';
import { createStyles } from './styles';
import { ATTRIBUTE_COVERED_TAG_TEST_ID, ATTRIBUTE_NOT_COVERED_TAG_TEST_ID } from '../constants';

export interface AttributeCoverageTagProps {
  isAttributeCovered: boolean;
}

const AttributeCoverageTag = ({ isAttributeCovered }: AttributeCoverageTagProps): JSX.Element => {
  const classes = createStyles();

  return isAttributeCovered ? (
    <p className={clsx(classes.tag, classes.coveredTag)} data-test-id={ATTRIBUTE_COVERED_TAG_TEST_ID}>
      Covered
    </p>
  ) : (
    <p className={clsx(classes.tag, classes.notCoveredTag)} data-test-id={ATTRIBUTE_NOT_COVERED_TAG_TEST_ID}>
      Not covered
    </p>
  );
};

export default AttributeCoverageTag;
